import script from "./CategoryCheckBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryCheckBox.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryCheckBox.vue?vue&type=style&index=0&id=642a9088&scoped=true&lang=css"
import "./CategoryCheckBox.vue?vue&type=style&index=1&id=642a9088&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642a9088"]])

export default __exports__
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QOptionGroup});
